import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  min-height: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    background-color: ${ColorPalette.HEX.Lotion};
  }
`;

export const ButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  background: ${ColorPalette.HEX.White};

  margin-top: auto;
  padding: 16px;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-gap: 16px;
  }
`;
